module.exports = __webpack_public_path__ + "static/media/building_white.86774017.svg";